import { defaultTheme, LayerStyles } from './themes/default'
import { mobilesyrup } from './themes/mobilesyrup'
import { ratehub } from './themes/ratehub'
import { francoischarron } from './themes/francoischarron'
import { protegezvous } from './themes/protegezvous'
import { lactualite } from './themes/lactualite'
import { redflagdeals } from './themes/redflagdeals'

const theme = {
  default: defaultTheme,
  mobilesyrup,
  ratehub,
  francoischarron,
  protegezvous,
  lactualite,
  redflagdeals,
  LayerStyles,
}
export default theme
